

module.exports = __webpack_require__.stylable.create(
    "index2639576315",
    {"classes":{"root":"index2639576315__root","textAlignmentMixin":"index2639576315__textAlignmentMixin","plan":"index2639576315__plan","planTop":"index2639576315__planTop","currency":"index2639576315__currency","price":"index2639576315__price","duration":"index2639576315__duration","planWrapper":"index2639576315__planWrapper","ctaWrapper":"index2639576315__ctaWrapper"},"vars":{"shadowXOffset":"--index2639576315-shadowXOffset","shadowYOffset":"--index2639576315-shadowYOffset"},"stVars":{"shadowXOffset":"0px","shadowYOffset":"0px"},"keyframes":{}},
    "",
    15,
    "index2639576315",
    null
);
